module.exports = __webpack_public_path__ + "static/media/newyork.9c233d75.png";